<script>
  import {media} from 'svelte-match-media'
  import ViewSource from '../components/ViewSource.svelte'
  import ChartDotKey from '../svgs/ChartDotKey.svelte'
</script>

<div class="chart">
  <h4 class="title">Which CTV publishers reached the most households beyond my linear TV buy?</h4>

  {#if $media.mobile}
    <svg width="343" height="127" viewBox="0 0 343 127" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="89" y="56" width="38" height="52" class="gray"/>
      <rect x="127" y="76" width="38" height="32" class="red"/>
      <rect x="178" y="52" width="38" height="56" class="gray"/>
      <rect x="216" y="56" width="38" height="52" class="red"/>
      <rect y="1" width="38" height="108" class="gray"/>
      <rect x="38" y="25" width="38" height="84" class="red"/>
      <rect x="267" y="100" width="38" height="8" class="gray"/>
      <rect x="305" y="104" width="38" height="4" class="red"/>
      <text class="white bold small"><tspan x="10" y="124.032">Network A</tspan></text>
      <text class="white bold small"><tspan x="98" y="124.032">Network B</tspan></text>
      <text class="white bold small"><tspan x="188" y="124.032">Network C</tspan></text>
      <text class="white bold small"><tspan x="275" y="124.032">Network D</tspan></text>
      <text class="white"><tspan x="21" y="85.069">$0.15</tspan></text>
      <text class="white"><tspan x="197" y="85.069">$0.09</tspan></text>
      <text class="white"><tspan x="290" y="13.069">$0.42</tspan></text>
      <text class="white"><tspan x="110" y="40.069">$0.28</tspan></text>
      <path d="M39 92.5L128.5 71.5L216 92L308 44.5" stroke="white" stroke-width="1.4" stroke-miterlimit="16" stroke-linecap="round" stroke-dasharray="1 3"/>
    </svg>
  {:else}
  <svg width="596" height="196" viewBox="0 0 596 196" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="155" y="87.0001" width="66" height="81" class="gray"/>
    <rect x="221" y="118" width="66" height="50" class="red"/>
    <rect x="310" y="81" width="66" height="87" class="gray"/>
    <rect x="376" y="87" width="66" height="81" class="red"/>
    <rect width="66.0001" height="167.999" class="gray"/>
    <rect x="66" y="37.3345" width="66.0001" height="130.666" class="red"/>
    <rect x="464" y="155" width="66" height="13" class="gray"/>
    <rect x="530" y="161" width="66" height="7" class="red"/>
    <text class="white bold large"><tspan x="27.9004" y="191.811">Network A</tspan></text>
    <text class="white bold large"><tspan x="182.549" y="191.811">Network B</tspan></text>
    <text class="white bold large"><tspan x="340.671" y="191.811">Network C</tspan></text>
    <text class="white bold large"><tspan x="493.58" y="191.811">Network D</tspan></text>
    <text class="white large"><tspan x="45.2773" y="125.621">$0.15</tspan></text>
    <text class="white large"><tspan x="354.096" y="125.621">$0.09</tspan></text>
    <text class="white large"><tspan x="510.169" y="15.736">$0.42</tspan></text>
    <text class="white large"><tspan x="202.137" y="55.6928">$0.28</tspan></text>
    <path d="M66 104L222.5 66L376 104.5L531 26" stroke="white" stroke-width="1.4" stroke-miterlimit="16" stroke-linecap="round" stroke-dasharray="1 3"/>
  </svg>
    
  {/if}
    
  <div class="key">
    <div class="key1 item"><div class="block"></div><p class="name">Total reach</p></div>
    <div class="key2 item"><div class="block"></div><p class="name">Intl Reach</p></div>
    <div class="key3 item"><ChartDotKey /><p class="name">Cost per incremental Household</p></div>
  </div>
  <ViewSource id="ctv_publishers_hh_reach">Internal data, Aug 2020.</ViewSource>
  <p class="takeaway accent"><strong>Key takeaway:</strong></p>
  <ul>
    <li><p>Cut back on Networks B and D, since they were least efficient in getting incremental reach.</p></li>
  </ul>
</div>

<style>
  .title {
    margin: 0 0 40px;
  }

  svg text {
    font-family: inherit;
    white-space: pre;
    font-size: 14px;
    font-weight: 500;
  }
  .white {
    fill: white;
  }
  .gray {
    fill: var(--gray-link);
  }
  .bold {
    font-weight: bold;
  }
  .large {
    font-size: 16px;
  }
  .small {
    font-size: 12px;
  }
  .red {
    fill: var(--verizon-red)
  }
  .key {
    display: flex;
    flex-wrap: wrap;
    font-weight: 500;
    font-size: 12px;
    margin: 10px -8px -5px -8px;
  }
  .key .name {
    margin: 0;
  }
  .key .item {
    display: flex;
    padding: 8px;
    white-space: nowrap;
  }
  .key .block {
    width: 12px;
    height: 12px;
    margin-right: 8px;
    transform: translateY(1.5px)
  }
  .key1 .block {
    background: var(--gray-link)
  }
  .key2 .block {
    background: var(--verizon-red)
  }
  .key3 {
    align-items: center;
  }
  .key3 :global(svg) {
    margin-right: 8px;
  }
  @media(min-width: 768px) {
    svg {
      width: 100%;
      height: auto;
    }
    .key {
      margin-top: 24px;
    }
  }
</style>